import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "error-msg" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "error-msg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass({
            error: ($props.parent == '' && $props.v$ && $props.v$.value && $props.v$.value[$props.propname ?? $props.name] && $props.v$.value[$props.propname ?? $props.name].$errors.length) ||
                ($props.parent != '' && $props.v$ && $props.v$.value && $props.v$.value[$props.parent] && $props.v$.value[$props.parent].$each.$response.$errors.length && $props.v$.value[$props.parent].$each.$response.$errors[$props.propname ?? $props.name.split('_')[0]][$props.propname ?? $props.name.split('_')[1]].length)
        })
    }, [
      _createVNode(_component_MultiSelect, {
        id: $props.name,
        name: $props.name,
        modelValue: $props.modelValue,
        placeholder: $props.placeholder,
        options: $setup.ListOption,
        optionLabel: $props.optionLabel,
        optionValue: $props.optionValue,
        filter: $props.filter,
        showToggleAll: $props.showToggleAll,
        maxSelectedLabels: $props.maxSelectedLabels,
        loading: $setup.Isloading,
        onInput: _cache[0] || (_cache[0] = ($event: any) => ($setup.updateValue($event.target.value))),
        onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateValue($event.value))),
        disabled: $props.disabled,
        readonly: $props.readonly,
        optionGroupLabel: $props.optionGroupLabel,
        optionGroupChildren: $props.optionGroupChildren
      }, {
        option: _withCtx((slotProps) => [
          _createElementVNode("div", {
            class: _normalizeClass(["GroupDrop-items", slotProps.option.IsLeave == true ? 'Leave' : ''])
          }, [
            _createElementVNode("div", null, _toDisplayString(slotProps.option.Text), 1 /* TEXT */),
            ($props.IsShowCount)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "openItem",
                  onClick: ($event: any) => ($setup.ShowCountClick(slotProps.option.Value, slotProps.option.Count))
                }, _toDisplayString(slotProps.option.Count), 9 /* TEXT, PROPS */, _hoisted_1))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["id", "name", "modelValue", "placeholder", "options", "optionLabel", "optionValue", "filter", "showToggleAll", "maxSelectedLabels", "loading", "disabled", "readonly", "optionGroupLabel", "optionGroupChildren"]),
      (($props.modelValue || []).length > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "clearValueBtn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.updateValue('')))
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "pi pi-times" }, null, -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    ($props.v$ && $props.v$.value && $props.v$.value[$props.propname ?? $props.name])
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.v$.value[$props.propname ?? $props.name].$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "input-errors",
              key: error.$uid
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(error.$message), 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    ($props.parent != '' && $props.v$ && $props.v$.value && $props.v$.value[$props.parent] && $props.v$.value[$props.parent].$each.$response.$errors.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.v$.value[$props.parent].$each.$response.$errors[$props.propname ?? $props.name.split('_')[0]][$props.propname ?? $props.name.split('_')[1]], (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "input-errors",
              key: error.$uid
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(error.$message), 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}